import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import Header from "./content/header"
import {Helmet} from 'react-helmet'
import api from "../../services/api"


class MeuscursosUser extends Component {

  state = {
    matriculas:[],
    linktopay:null,
    codepay:null,
    statuspay:null
  }


  async shouldComponentUpdate(nextProps, nextState){

    if(nextState.idpay!==this.state.idpay){
      nextState.statuspay="Carregando";
      this.pay(nextState.idpay);
    }
    return true;
  }



  async pay(idpay){

    const response = await api.post("/matricula/pay", {idmatricula:idpay});
    this.setState({
      codepay:response.data.code
    });

    window.location.href = "https://pagseguro.uol.com.br/v2/checkout/payment.html?code="+this.state.codepay;



  }



  async componentDidMount(){
    document.getElementById("cursosmenu").classList.toggle("bg-light");

    const response = await api.get("/user/matriculas");
    this.setState({
      matriculas:response.data
    })

  }


    togglemenu = ()=> {
        document.getElementById("sidebar").classList.toggle("active");
        document.getElementById("content").classList.toggle("active");
    }

  render() {
  
    const widthtable ={
      width:'144px',
    }

    return (
        
      <React.Fragment>
        <Header />
        <Helmet>
            <title>Minhas Matriculas | Faculdade Olga Mettig</title>
        </Helmet>

<div class="page-content white" id="content">
  

  <button id="sidebarCollapse" onClick={this.togglemenu} type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-bars mr-2"></i><small class="text-uppercase font-weight-bold">Toggle</small></button>
  
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/user">Pagina Inicial</a></li>
            <li class="breadcrumb-item"><a href="/user/cursos">Minhas Matriculas</a></li>
        </ol>
    </nav>

  
 
  <div class="separator"></div>
  
  <div class="row text-black contentp">
    
    <div class="col-lg-12">
    <center><h4>Minhas Matriculas</h4></center>
    <br></br>
    <center>{this.state.statuspay && <p>{this.state.statuspay}</p>}</center>
    <table class="table table-hovertable-bordered table-bordered">
  <thead class="blue white-text">
    
    <tr>
      <th scope="col">#ID</th>
      <th scope="col">Curso</th>
      <th scope="col">Modalidade</th>
      <th style={widthtable} >Valor Matricula</th>
      <th style={widthtable}>Valor Mensalidade</th>
      <th scope="col">Status</th>
      <th scope="col">Ação</th>
    </tr>
  </thead>
  <tbody>
  {this.state.matriculas.map(el => (
    <tr>
      <th scope="row">{el.id}</th>
      <td>
        <center>
          <a href={'/pos-graduacao/'+el.pos_curso.longnome+'/'+el.pos_curso.id+''} target="_blank">{el.pos_curso.nome}</a>
        </center>
      </td>
    <td>{el.isead==true?"EAD":"Presencial"}</td>
      <td ><center>R${el.price}</center></td>
      <td><center>R${el.pos_curso.preco}</center></td>

      {
      el.status==0 && 
      <td>Pendente</td>
      }
      {
      el.status==1 && 
      <td>Ativo</td>
      }
      {
      el.status==2 && 
      <td>Cancelado</td>
      }
      {
      el.status==4 && 
      <td>Concluído</td>
      } 
      {
      el.status==5 && 
      <td>Concluido com pendência</td>
      } 
      {
      el.status==6 && 
      <td>Formado</td>
      } 
       {
      el.status==7 && 
      <td>Ativo Totalmente Pago</td>
      } 

     
      <td>
      {
      el.paid==0 && 
      <a onClick={e => this.setState({ idpay: el.id} )} class="btn btn-danger btn-sm">Pagar</a>
      }
      {
      el.paid==1 && 
      <button class="btn btn-success btn-sm">Pago</button>
      }


      
      
      </td>
    </tr>
  ))}
    
  </tbody>
</table>
    </div>
    
  </div>

</div>


      </React.Fragment>
       
    );
  }
}

export default withRouter(MeuscursosUser);


// WEBPACK FOOTER //
// ./src/pages/User/meuscursos.js